import { PoTypeDto } from './../model/po-type-dto';

import { RoleDto } from './../model/role-dto';
import { Injectable } from '@angular/core';
import { PartnerDto } from '../model/partner-dto';
import { Menubardto } from '../model/menubardto';
import { OrderItemMasterDto } from '../model/order-item-master-dto';
import { PartnerOnboardingMasterDto } from '../model/partner-onboarding-master-dto';

@Injectable({
  providedIn: 'root'
})
export class AppSettingService {
  public serviceKingId = '079341848';
  public globelDateFormat: string;
  public globelDateTimeFormat = 'MM/dd/yyyy HH:mm';
  public globelDateTimeSecFormat = 'MM/dd/yyyy HH:mm:ss';
  public globelDatePickerFormat = 'MM/DD/YYYY';
  public globelDatePickerInUSAFormat = 'MM/dd/yyyy';
  public exportList: string[] = ['Excel', 'PDF'];
  public paginationList = [{paginationLabel: '25 per page', paginationValue: '25'},
                           {paginationLabel: '50 per page', paginationValue: '50'},
                           {paginationLabel: '100 per page', paginationValue: '100'}];
  public paginationListWith10 = [{paginationLabel: '10 per page', paginationValue: '10'},
                           {paginationLabel: '20 per page', paginationValue: '20'},
                           {paginationLabel: '30 per page', paginationValue: '30'},
                           {paginationLabel: '40 per page', paginationValue: '40'}];

  public partnerMSOGlobelList: PartnerDto[];
  public partnerJobberGlobelList: PartnerDto[];
  public customerMatlDropDownGlobelList: PartnerDto[];
  public customerMSOGlobelList: PartnerDto[];
  public menubarGlobelList: Menubardto[];
  public m2mDbDefaultSearchDaysLimit: string;
  public m2mDbMaxRowsLimit: string;
  public m2mDbSearchKeyDaysLimit: string;
  public roleGlobelList: RoleDto[];
  public orderItemMasterDtoList: OrderItemMasterDto[];
  public poTypeDtoMasterList: PoTypeDto[];
  public globelUserId: string;
  public isPartner: boolean;
  public userLocationList: String[];
  sourceAndTargetGlobelList: PartnerOnboardingMasterDto[];
  partnerTypeGlobelList: PartnerOnboardingMasterDto[];
  orderFlowTypeGlobelList: PartnerOnboardingMasterDto[];
  refCodeGlobelList: PartnerOnboardingMasterDto[];
  partnerNumberGlobelList: PartnerOnboardingMasterDto[];
  partnerRefCodeGlobelList: PartnerOnboardingMasterDto[];


  constructor() { }

  clearGlobelVariable() {
    this.partnerMSOGlobelList = null;
    this.partnerJobberGlobelList = null;
    this.customerMSOGlobelList = null;
    this.menubarGlobelList = null;
    this.poTypeDtoMasterList = null;

    }
}
